<template>
  <div>
    <div class="form-group">
      <h3 :class="template.style.surveyBackground ? 'text-white' : 'text-dark'"
          class="  font-weight-bold text-center" for="nome"> {{ questionText }}</h3>
      <p class="observation">{{ questionObs }}</p>
<!--      <input-->
<!--          type="text"-->
<!--          class="form-control"-->
<!--          :placeholder="getPlaceHolder"-->
<!--          v-model="qtAnwser"-->
<!--          v-on:click="showList"-->
<!--          v-show="showInput"-->
<!--      />-->
      <!--v-on:keydown="allKeys"-->
    </div>

    <span></span>

    <div
        class="q-buttonlist-selected"
        vs-align="center"
        vs-type="flex"
        vs-justify="space-around"
        v-show="showSelected"
    >
      <div
          v-for="(opt, index) in answerList"
          v-bind:key="index"
          class="align-middle"
      >
        <vs-icon
            icon="done"
            :color="'#038835'"
            v-on:click="removeOption(opt)"
            class="align-middle iconDeselect"
        ></vs-icon>
        <label :color="'#038835'">{{ opt }}</label>
      </div>
    </div>

    <vs-row class="sur-qtext" vs-type="flex" vs-justify="space-around">
      <vs-col vs-lg="6" vs-xs="12" vs-sm="12" vs-type="flex" vs-justify="center" class="p-2" v-for="(opt, index) in newList" v-bind:key="index">
        <vs-card class="img-btn" style="background-color: #fff;">
          <h4 class="text-center pt-3 mb-4">
            {{ opt.text }}
          </h4>
          <div style="text-align: center; position: relative">
            <div v-if="opt.format === 'youtube'"
                 style="background-position: center center; background-size: cover; aspect-ratio: 16 / 9; max-width: 640px; margin: 0 auto"
                 :style="{backgroundImage: `url('http://img.youtube.com/vi/${opt.linkId}/0.jpg')`}">
              <div class="h-100 w-100" style="background-color: rgba(0,0,0,.6)">
                <youtube style="height: 100%; position: relative; z-index: 30"
                         :key="opt.reloadKey"
                         :video-id="opt.linkId"
                         player-width="100%"
                         player-height="100%"
                         :player-vars="{controls: 0, playsinline: 0, rel: 0, start: opt.start, end: opt.end}"
                         @ended="ended(index)"
                ></youtube>
              </div>
            </div>
            <div v-else style="aspect-ratio: 16 / 9; max-width: 640px; margin: 0 auto" >
              <div class="h-100 w-100" style="background-color: rgba(0,0,0,.6)">
                <video width="100%" height="100%" controls style="position: relative; z-index: 30">
                  <source :src="opt.linkId" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
            <!-- loading spinner -->
            <span
              class="spinner-border spinner-border-lg spinner-video text-white"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
          <vs-row>
            <button v-if="!answerList.includes(opt.text)" type="button" style="padding: 15px 5px;"
                    class="btn btn-primary w-100 font-weight-bold btn-block mt-2 mx-auto"
                    v-on:click="ChooseOption(opt.text, $event)">
              VOTAR
            </button>
            <button v-else type="button" style="padding: 15px 5px;"
                    class="btn btn-primary w-100 font-weight-bold btn-block mt-2 mx-auto c-seledted-btn"
                    v-on:click="removeOption(opt.text, $event)">
              <vs-icon
                  icon="done"
                  :color="'#038835'"
                  v-on:click="removeOption(opt)"
                  class="align-middle iconDeselect"
              ></vs-icon>
              REMOVER VOTO
            </button>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

const configDomain = process.env.VUE_APP_CONFIGDOMAIN;

import {mask} from "vue-the-mask";

export default {
  name: "Survey-Input-List",
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    show: false,
    showInput: true,
    list: [],
    answerList: [],
    nMax: 1,
    nselected: 0,
    newList: []
  }),
  directives: {mask},
  props: {
    questionText: {type: String},
    questionObs: {type: String},
    questionId: {type: Number},
    options: [],
    config: {type: String}
  },
  computed: {
    showSelected: function () {
      if (this.nselected > 0) return true;
      else return false;
    },
    getPlaceHolder() {
      if (this.placeHolder) return this.placeHolder;
      else return this.$t('type_here');
    },
    template() {
      return this.$store.state.template
    }
  },
  watch: {
    qtAnwser() {
      this.allKeys();
    }
  },
  created() {
    this.showInput = true;
    this.show = false;

    if (this.config) {
      if (this.config.includes("noinput")) {
        this.showInput = false;
        this.show = true;
      }

      if (this.config.includes("n:")) {
        var opts = this.config.split(";");
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].includes("n:")) {
            var r = opts[i].split(":");
            if (r[1] == "x") this.nMax = this.options.length;
            else this.nMax = r[1];
          }
        }
      }
    }
    // this.answerList = new Array(this.nMax);

    //Verificar respostas anteriores:

    if (this.$store.getters.answerValue(this.questionId)) {
      var Anwser = this.$store.getters.answerValue(this.questionId);
      this.answerList = [];
      var s = Anwser.split(";");
      if (s.length == 1) {
        this.answerList.push(s[0]);
        this.nselected++;
      }
      for (i = 0; i < s.length - 1; i++) {
        this.answerList.push(s[i]);
        this.nselected++;
      }
      this.multiSelectChanged();
      this.show = true;
    } else this.list = this.options;
    this.processList()
  },
  methods: {
    imgpath(index) {
      const s = `${configDomain}/prj/${this.$store.state.project.projectID}/${this.questionId}_${index + 1}.webp`;
      return s;
    },
    imgpathZoom(index) {
      const s = `${configDomain}/prj/${this.$store.state.project.projectID}/${this.questionId}_${index + 1}_zoom.webp`;
      return s;
    },
    getBtnType: function (value) {
      if (this.answerList.length != 0) {
        if (this.answerList.includes(value)) return "filled";
        else {
          return "border";
        }
      } else {
        return "border";
      }
    },
    allKeys() {
      this.newList = [];
      //filtrar a lista
      for (var i = 0; i < this.options.length; i++) {
        //if (this.options[i].text.toUpperCase().startsWith(this.qtAnwser.toUpperCase().trim()))
        if (!this.answerList.includes(this.options[i].text))
          if (
              this.options[i].text
                  .toUpperCase()
                  .includes(this.qtAnwser.toUpperCase().trim())
          )
            this.newList.push(this.options[i]);
      }
      //this.show = true;
      //this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    mountAnswer: function () {
      var resp = "";
      for (var i = 0; i < this.answerList.length; i++) {
        resp = resp + this.answerList[i] + ";";
      }
      return resp;
    },
    removeOption(opt) {
      var ln = [];
      //somente remontamos a lista
      for (var i = 0; i < this.answerList.length; i++) {
        if (this.answerList[i] != opt) ln.push(this.answerList[i]);
      }

      this.answerList = ln;
      this.multiSelectChanged();

      this.nselected--;
      var resp = this.mountAnswer();
      this.$emit("AnswerChanged", resp, this.questionId);
    },

    multiSelectChanged() {
      this.newList = [];

      // remonta a lista - com todas opções
      this.newList = [...this.options]

      //remonta a lista - removendo a escolhida
      // for (var i = 0; i < this.options.length; i++) {
      //   if (!this.answerList.includes(this.options[i].text))
      //     this.list.push(this.options[i]);
      // }
    },

    showList() {
      this.show = true;
    },
    CheckEscape(value) {
      var escape = false;
      if (this.config.includes("escape=")) {
        var opts = this.config.split(";");

        for (var i = 0; i < opts.length; i++) {
          if (opts[i].includes("escape=")) {
            var r = opts[i].split("=");
            if (r[1].includes(value)) escape = true;
          }
        }
      }
      return escape;
    },
    ChooseOption(opt, event) {
      if (this.nMax == 1 || this.CheckEscape(opt)) {
        if (this.showInput) this.show = false;
        this.qtAnwser = opt;
        this.answerList = [];
        this.answerList.push(opt);

        this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
      } else {
        var resp = "";
        if (this.nselected <= this.nMax) {
          this.nselected++;
          this.answerList.push(opt);
          resp = this.mountAnswer();
          this.multiSelectChanged();
          if (this.nselected == this.nMax) {
            this.$emit("QuestionAnwered", resp, this.questionId);
          } else {
            this.$emit("AnswerChanged", resp, this.questionId);
          }
        } else {
          //    this.multiSelectChanged();
          event.stopPropagation();
        }
      }
    },
    processList() {
      this.list.forEach(item => {
        let obj = {}
        obj.text = item.text
        obj.ilustration = item.ilustration
        obj.reloadKey = true // just to reload the video component when ended
        let array = item.ilustration.split('&')
        array.forEach(el => {
          const prop = el.split('=')[0]
          obj[prop] = el.split('=')[1]
        })
        this.newList.push(obj)
      })
    },
    ended(index) {
      this.newList[index].reloadKey = !this.newList[index].reloadKey
    },
  }
};
</script>

<style scoped>
.c-seledted-btn {
  background-color: black;
  color: white;
}
.c-seledted-btn:hover {
  background-color: black !important;
  opacity: 0.8;
}

.img-btn:hover {
  transform: scale(1.05);
}

.spinner-video {
  position: absolute;
  inset: auto;
  top: 40%;
  left: 50%;
  margin-left: -1rem;
  z-index: 20;
}

/* .question .form-group > label {
  font-size: 1.25rem;
  letter-spacing: -0.48px;
  font-weight: bold;
}
.question .form-group input {
  border: none;
  border-left: 2px solid #038835 !important;
  font-size: 1.5rem;
  margin: 1rem 0 0;
}
.question .form-group input:focus {
  border: none !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255) !important;
  border-left: 2px solid #038835 !important;
}
.question form .btn-primary {
  width: 50% !important;
  display: inline-block !important;
}
.question form .instrucao {
  display: inline-block;
}

.iconx {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: solid 1px #dfe2e6;
  color: #dfe2e6;
}

.btnOtion {
  width: 100%;
}

.q-title {
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #40424a;
}

.q-list-answer {
  width: 351px;
  height: 40px;
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #40424a;
  display: inline-block;
  vertical-align: middle;
}

.q-text-answer .text-style-1 {
  color: #038835;
} */
</style>
